import React, { useRef } from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'

import { MAP_SETTINGS_IMAGES } from '../../../assets'

import HeatMapOptions from './HeatMapOptions'
import useClickOutside from '../../common/useClickOutside'

const HeatMapSettings = ({ t, uiStore }) => {
  const heatmapSettingsRef = useRef(null)

  useClickOutside(heatmapSettingsRef, () => uiStore.hideHeatmapSettings(), uiStore.isHeatmapSettingsVisible)

  return (
    <div ref={heatmapSettingsRef} className='map-controls__heatmap'>
      <button type='button' className={`map-controls__heat-btn ${uiStore.isDensityMapActive ? 'active' : ''}`} onClick={() => { uiStore.toggleHeatmap() }}>
        <img className='map-controls__heat-img' src={MAP_SETTINGS_IMAGES.HEAT_MAP} alt='Heatmap graphic' />
        <span className='map-controls__heat-text'>{t('MAP_SETTINGS.HEAT')}</span>
      </button>
      <button type='button' className='map-controls__show-options' onClick={() => uiStore.toggleHeatmapSettings()}>
        <span className='map-controls__dots' />
      </button>
      {uiStore.isHeatmapSettingsVisible &&
        <HeatMapOptions />}
    </div>
  )
}

export default inject('uiStore')(withTranslation()(observer(HeatMapSettings)))
